import { render, staticRenderFns } from "./SapSync.vue?vue&type=template&id=5bed2420"
import script from "./SapSync.vue?vue&type=script&lang=js"
export * from "./SapSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports